<template>
    <div>
        <div class="more-btn-no" @mouseenter="isSuspended = true" v-show="!isSuspended">
            <div class="btn-txt">立即体验</div>
            <div style="width: 8px;"></div>
            <img class="btn-img" style="width: 14px;height: 12px;" src="../../assets/right-huang.png" />
        </div>
        <div class="more-btn" @mouseleave="isSuspended = false" v-show="isSuspended">
            <div class="btn-txt">立即体验</div>
            <div style="width: 8px;"></div>
            <img class="btn-img" style="width: 14px;height: 12px;"
                src="../../assets/career_panorama/youjianto-bai.png" />
        </div>
    </div>

</template>

<script>
export default {
    name: 'experience-now',
    data() {
        return {
            isSuspended: false
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.more-btn-no {
    width: 116px;
    height: 38px;
    background: #FFFFFF;
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
    border-radius: 21px;
    border: 2px solid #FF6E00;
    color: #FF6503;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    font-style: normal;
}

.more-btn {
    width: 120px;
    height: 42px;
    background: #FF6503;
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .btn-txt {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: white;
        line-height: 22px;
        text-align: center;
        font-style: normal;

    }

    .btn-img {
        width: 14px;
        height: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ExperienceNow/experienceNow.vue